/** A plain object (an object literal, or one with no prototype); a Date, Map, array or class instance is not. */
const isPlainObject = (value) => {
  if (value === null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

/**
 * Merges a settings save into stored settings, two levels deep: every top-level setting is kept,
 * and within a top-level setting each sub-setting the save names replaces the stored one whole.
 * Callers save whole sub-settings ({ PoliciesListView: { searchConfig } }, { [viewKey]:
 * { columnsOptions } }), so a value cleared by saving an empty object (sort: {}) stays cleared,
 * while a list's columns survive a save of its search configuration. Only plain objects are merged
 * into; anything else replaces the stored value. Returns a new object.
 */
export const mergeSettings = (stored, next) => {
  const result = { ...stored };
  Object.keys(next).forEach((key) => {
    const value = next[key];
    result[key] = isPlainObject(value) && isPlainObject(stored[key]) ? { ...stored[key], ...value } : value;
  });
  return result;
};
